import _ from "lodash";
import ACTIONS from "../actions/KYBTestCacheActions";

const initialState = {
    kybTestcacheObject: {
        id: "",
        organization_name: "",
        business_id: "",
        business_id_type: "",
        addressline1: "",
        locality: "",
        province: "",
        postalcode: "",
        countrycode: "",
        phone_number: "",
        full_email_address: "",
        domain: "",
        datasource: "",
        modified_date: "",
    },
    addKYBTestcacheModalOpen: false,
    editKYBTestcacheModalOpen: false,
    deleteKYBTestcacheWarning: false,
    showKYBPostmanRequest: false,
    kybTestcacheIDForDelete: null,
    kybPostmanObject: {
        "options": "businessverify;messageverbose;debug",
        "credentials": {
            "tenant": "",
            "username": "",
            "password": ""
        },
        "address": {
            "thoroughfare": "",
            "houseNumber": "",
            "locality": "",
            "postalCode": "",
            "province": "",
            "countryCode": ""
        },
        "identity": {
            "completename": "",
            "organization_name": "",
            "givenfullname": "",
            "surname_first": "",
            "nationalid": "",
            "businessid": "",
            "dob": "",
            "codes": {
                "messages": [
                    {
                        "code": "",
                        "value": ""
                    }
                ]
            }
        },
        "phone": {
            "phone_number": ""
        },
        "email": {
            "full_email_address": "",
            "domain": ""
        }
    }
}

const addEditKYBTestCacheReducer = (state = initialState, action) => {
    switch (action.type) {

        case ACTIONS.KYBTestcacheActionTypes.TOGGLE_ADD_KYB_TESTCACHE_MODAL: {
            let newState = _.cloneDeep(state);
            newState.addKYBTestcacheModalOpen = !newState.addKYBTestcacheModalOpen;
            // reset the form to placeholder values
            if (!newState.addKYBTestcacheModalOpen) {
                newState.kybTestcacheObject = initialState.kybTestcacheObject;
                newState.kybPostmanObject = initialState.kybPostmanObject;
            }
            return newState
        }

        case ACTIONS.KYBTestcacheActionTypes.TOGGLE_EDIT_KYB_TESTCACHE_MODAL: {
            let newState = _.cloneDeep(state);
            newState.editKYBTestcacheModalOpen = !newState.editKYBTestcacheModalOpen;
            // reset the form to placeholder values
            if (!newState.editKYBTestcacheModalOpen) {
                newState.kybTestcacheObject = initialState.kybTestcacheObject;
                newState.kybPostmanObject = initialState.kybPostmanObject;
            }
            return newState
        }

        case ACTIONS.KYBTestcacheActionTypes.OPEN_EDIT_KYB_TESTCACHE_MODAL: {
            let newState = _.cloneDeep(state);
            newState.kybTestcacheObject = action.payload;
            newState.editKYBTestcacheModalOpen = !newState.editKYBTestcacheModalOpen;

            // Map KYB fields to Postman object
            newState.kybPostmanObject.address.thoroughfare = newState.kybTestcacheObject.addressline1;
            newState.kybPostmanObject.address.locality = newState.kybTestcacheObject.locality;
            newState.kybPostmanObject.address.province = newState.kybTestcacheObject.province;
            newState.kybPostmanObject.address.postalCode = newState.kybTestcacheObject.postalcode;
            newState.kybPostmanObject.address.countryCode = newState.kybTestcacheObject.countrycode;
            newState.kybPostmanObject.identity.organization_name = newState.kybTestcacheObject.organization_name;
            newState.kybPostmanObject.identity.businessid = newState.kybTestcacheObject.business_id;
            newState.kybPostmanObject.phone.phone_number = newState.kybTestcacheObject.phone_number;
            newState.kybPostmanObject.email.full_email_address = newState.kybTestcacheObject.full_email_address;
            newState.kybPostmanObject.email.domain = newState.kybTestcacheObject.domain;

            return newState
        }

        case ACTIONS.KYBTestcacheActionTypes.SETTING_KYB_TESTCACHE_FORM_OBJECT_VALUE: {
            let newState = _.cloneDeep(state);
            newState.kybTestcacheObject[action.payload.name] = action.payload.value;
            return newState
        }

        case ACTIONS.KYBTestcacheActionTypes.SET_KYB_COUNTRY: {
            let newState = _.cloneDeep(state);
            if (action.payload.country != null) {
                newState.kybTestcacheObject.countrycode = action.payload.country.value;
            } else {
                newState.kybTestcacheObject.countrycode = "";
            }
            return newState;
        }

        case ACTIONS.KYBTestcacheActionTypes.SET_KYB_SOURCE_TYPE: {
            let newState = _.cloneDeep(state);
            if (action.payload.datasource != null) {
                newState.kybTestcacheObject.datasource = action.payload.datasource.value;
            } else {
                newState.kybTestcacheObject.datasource = "";
            }
            return newState;
        }

        case ACTIONS.KYBTestcacheActionTypes.GENERATE_KYB_POSTMAN_REQUEST: {
            let newState = _.cloneDeep(state);
            newState.kybPostmanObject.address.thoroughfare = newState.kybTestcacheObject.addressline1;
            newState.kybPostmanObject.address.locality = newState.kybTestcacheObject.locality;
            newState.kybPostmanObject.address.province = newState.kybTestcacheObject.province;
            newState.kybPostmanObject.address.postalCode = newState.kybTestcacheObject.postalcode;
            newState.kybPostmanObject.address.countryCode = newState.kybTestcacheObject.countrycode;
            newState.kybPostmanObject.identity.organization_name = newState.kybTestcacheObject.organization_name;
            newState.kybPostmanObject.identity.businessid = newState.kybTestcacheObject.business_id;
            newState.kybPostmanObject.phone.phone_number = newState.kybTestcacheObject.phone_number;
            newState.kybPostmanObject.email.full_email_address = newState.kybTestcacheObject.full_email_address;
            newState.kybPostmanObject.email.domain = newState.kybTestcacheObject.domain;
            return newState;
        }

        case ACTIONS.apiActionsKYBTestcache.DELETE_WARNING_FOR_KYB_TESTCACHE: {
            let newState = _.cloneDeep(state);
            newState.deleteKYBTestcacheWarning = !newState.deleteKYBTestcacheWarning;
            newState.kybTestcacheIDForDelete = action.payload;
            return newState;
        }

        default:
            return state;
    }
}

export default addEditKYBTestCacheReducer;

